import React from 'react';
import Container from 'container';
import Headline from 'headline';
import { Link } from 'gatsby';
import ArticleCard from 'shared/article-card';
import Icon from 'icon';

import s from './article_group_1.module.scss';

const demoArticle = {
  title: 'This is the article title',
  date: '2019-05-23T18:38:10',
  image: 'placeholder',
  excerpt: `
    <p>
    Lorem ipsum, dolor sit amet consectetur adipisicing elit. Exercitationem
    ab aliquid accusantium molestiae temporibus in, inventore est nam veniam
    quia neque vel voluptates reiciendis eos alias accusamus id nemo quam
    fugiat porro consectetur nesciunt. Et fuga culpa dolore! Modi reiciendis
    aliquid nostrum illo doloribus reprehenderit eveniet laboriosam blanditiis
    in, accusamus, natus nemo maxime iure, voluptatem ipsum? Odio
  </p>`,
  categories: ['travel'],
  author: 'Joseph Casanova',
  editor: 'Elizabeth Williams',
  illustrator: 'Alexis Michaud'
};

export default function ArticleGroup1({
  title = 'category_title',
  category_slug,
  articles = new Array(5).fill(demoArticle),
}) {
  return (
    <Container className={s.root}>
      <div className={s.headerWrapper}>
        <Headline h2 title className={s.headline}>
          {title && title.replace(/&amp;/gmi, '&')}
        </Headline>
        <div className={s.allPosts}>
          <p className={s.allPostsText}>
            <Link to={`/${category_slug}`}>
            GO TO CATEGORY
              <Icon className={s.arrow} icon="arrow-circle" />
            </Link>
          </p>
        </div>
      </div>
      <div className={s.cards}>
        <div className={s.group}>
          <ArticleCard
            {...articles[0]}
            resize
            className={`${s.card} ${s.large}`}
          />
        </div>
        <div className={`${s.group} ${s.flex}`}>
          {articles.slice(1, 5).map((card) => (
            <ArticleCard
              {...card}
              resize
              key={Math.random()}
              className={`${s.card} ${s.small}`}
              slim
            />
              ))}
        </div>
      </div>
      <div className={s.bottomArticles}>
        {articles.slice(5, 8).map((card) => (
          <div className={s.bottomArticleWrapper}>
            <ArticleCard
              {...card}
              resize
              key={Math.random()}
              className={`${s.card} ${s.small}`}
              slim
            />
          </div>
      ))}
      </div>
    </Container>
  );
}
